export const commonRoutes = [
  {
    path: "/auth",
    name: "Auth",
    meta: { title: "加载中..." },
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/H5/auth/Auth.vue"),
  },
  {
    path: "/wechatauth",
    name: "WechatAuth",
    meta: { title: "登录中..." },
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/H5/auth/WechatAuth.vue"),
  },
  {
    path: "/platformwechatauth", // 平台授权登录
    name: "PlatformWechatAuth",
    meta: { title: "登录中..." },
    component: () =>
      import(
        /* webpackChunkName: "platformauth" */ "../views/H5/auth/PlatformWechatAuth.vue"
      ),
  },
  {
    path: "/meetwechatauth", // 大会授权登录
    name: "MeetWechatAuth",
    meta: { title: "登录中..." },
    component: () =>
      import(
        /* webpackChunkName: "meetwechatauth" */ "../views/H5/auth/MeetWechatAuth.vue"
      ),
  },
  {
    path: "/marketingwechatauth", // 营销活动授权登录
    name: "MarketingWechatAuth",
    meta: { title: "登录中..." },
    component: () =>
      import(
        /* webpackChunkName: "meetwechatauth" */ "../views/H5/auth/MarketingWechatAuth.vue"
      ),
  },
  {
    path: "/meetingwebwechatauth", // 大会官网授权登录
    name: "MeetingWebWechatAuth",
    meta: { title: "登录中..." },
    component: () =>
      import(
        /* webpackChunkName: "platformauth" */ "../views/H5/auth/MeetingWebWechatAuth.vue"
      ),
  },
  {
    path: "/eyewechatauth", // 眼科授权登录
    name: "EyeWebWechatAuth",
    meta: { title: "登录中..." },
    component: () =>
      import(
        /* webpackChunkName: "platformauth" */ "../views/H5/auth/EyeWechatAuth.vue"
      ),
  },
  {
    path: "/playAuth",
    name: "PlayAuth", //重播中转页
    meta: { title: "加载中..." },
    component: () => import("../views/H5/auth/PlayAuth.vue"),
  },
  {
    path: "/middleAuth",
    name: "MiddleAuth", //
    meta: { title: "加载中..." },
    component: () => import("../views/H5/auth/MiddleAuth.vue"),
  },
];
